import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import Layout from "@/components/layout";
import NProgress from "nprogress";
import "nprogress/nprogress.css"; // Progress 进度条样式
import { FormItem } from "element-ui";
import commonJs from "@/utils/common.js";

// const _import = require('./_import_' + process.env.NODE_ENV);
const _import = require("./_import_production");
// console.log(process.env.NODE_ENV);

Vue.use(VueRouter);

const VueRouterReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(to) {
  return VueRouterReplace.call(this, to).catch((err) => err);
};

const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};

const routes = [
  { path: "/", redirect: "/workbench" },
  // { path: '/index.html', redirect: '/' },
  // {
  //   path: '/test', component: _import("/test"), meta: {
  //     noAuth: true
  //   }
  // },
  {
    path: "/password",
    name: "password",
    component: Layout,
    children: [
      {
        path: "",
        component: _import("/password"),
        meta: { title: "修改密码", fullPath: "/password", isHide: true },
      },
    ],
  },
  {
    path: "/review",
    name: "review",
    component: Layout,
    children: [
      {
        path: "",
        component: _import("/review"),
        meta: { title: "审核列表", fullPath: "/review", isHide: true },
      },
    ],
  },
  {
    path: "/register",
    name: "register",
    component: _import("/login"),
    meta: {
      noAuth: true,
    },
  },
  {
    path: "/board",
    component: _import("/board"),
    meta: {
      title: "OAO跨境电商平台数据看板",
    },
  },
];

const router = new VueRouter({
  // mode: 'history',
  routes,
});

router.beforeEach((to, from, next) => {
  // let pathList = [
  //   "register",
  //   "workbench",
  //   "password",
  //   "review",
  //   "articles",
  //   "special",
  //   "organization",
  //   "links",
  //   "statistics",
  //   "web",
  //   "sy",
  // ];
  if (to.meta.noAuth) {
    sessionStorage.setItem("noToken", true);
  } else {
    sessionStorage.removeItem("noToken");
  }
  // if(to.meta.ColumnName){
  //   let head = document.getElementsByTagName('head');
  //   if(head[0].length-1) {
  //     head[0].removeChild([head[0].length-1])
  //   }
  //   let meta = document.createElement('meta');
  //   meta.content = to.meta.ColumnName;
  //   head[0].appendChild(meta)
  //  }
  if (to.meta.isFrontColumn) {
    window.scrollTo(0, 0);
  }
  NProgress.start();
  if (to.meta && to.meta.noAuth) {
    if (to.name != "register") {
      // store.dispatch("getIndexMenu");
      // store.dispatch("getDistrictList");
    }
    next();
  } else {
    /* 判断是否有已登录 */
    // console.log('判断是否有已登录',commonJs.getCookie("token") ? true : false)
    if (commonJs.getCookie("token") ? true : false) {
      /* 判断是否已读取身份信息 */
      // if (
      //   (from.meta.noAuth || to.meta.noAuth || from.path == "/") &&
      //   from.path !== "/register"
      // ) {
      //   if (pathList.indexOf(to.path.split("/")[1]) == -1) {
      //     next("/");
      //     return;
      //   }
      // }
      // console.log('判断是否已读取身份信息',store.getters.hasIdentityInfo)
      if (store.getters.hasIdentityInfo) {
        next();
      } else {
        /* 获取身份信息 */
        store.dispatch("getLimit");
        store.dispatch("getIdentityInfo").then((res) => {
          let permissionMenus = res.Menus;
          let permissionRouters = [];

          // permissionMenus.push({
          //   FullPath: "/sy/menus",
          //   FuncCodes: "Read,Write",
          //   FuncNames: "读,写",
          //   MenuId: 999,
          //   MenuName: "菜单管理",
          //   MenuType: 0,
          //   Meta: null,
          //   PermissionPath: "sy.menus",
          //   Pid: 1,
          //   Url: "menus",
          // });

          /*先取出顶级菜单，Pid为0的就是顶级菜单*/
          permissionMenus.forEach((m, i) => {
            if (m.Pid == 0) {
              let parentMenu = {
                path: m.FullPath,
                name: m.Url,
                component: Layout,
                meta: {
                  id: m.MenuId,
                  title: m.MenuName,
                  fullPath: m.FullPath,
                  icon: m.Url,
                },
              };
              permissionRouters.push(parentMenu);
            }
          });
          // function convertTree(routers) {
          //   routers.forEach(r => {
          //     permissionMenus.forEach((m, i) => {
          //       if (m.Pid != 0 && m.Pid == r.meta.id) {
          //         if (!r.children) r.children = []
          //         var path = m.FullPath;
          //         if (m.Url == 'webarticle' || m.Url == 'webvideo' || m.Url == 'download' || m.Url == 'links') {
          //           m.Url = m.Url + m.Meta.ColumnId;
          //           m.FullPath = m.FullPath + m.Meta.ColumnId;
          //         }

          //         let menu = {
          //           path: m.Url,
          //           name: m.Url,
          //           component: _import(path + "/"),
          //           meta: {
          //             id: m.MenuId,
          //             title: m.MenuName,
          //             fullPath: m.FullPath,
          //             ColumnId: m.Meta != null ? m.Meta.ColumnId : null,
          //             ColumnType: m.Meta != null ? m.Meta.ColumnType : null,
          //           }
          //         }
          //         r.children.push(menu)
          //       }
          //     })
          //     if (r.children) {
          //       convertTree(r.children)
          //     }
          //   })
          // }
          // convertTree(permissionRouters)
          function convertTree(routers) {
            routers.forEach((r) => {
              permissionMenus.forEach((m, i) => {
                if (m.Pid != 0 && m.Pid == r.meta.id) {
                  if (!r.children) r.children = [];
                  let menu = {
                    path: m.Url,
                    name: m.Url,
                    component: _import(m.FullPath + "/"),
                    meta: {
                      id: m.MenuId,
                      title: m.MenuName,
                      fullPath: m.FullPath,
                    },
                  };
                  r.children.push(menu);
                }
              });
              if (r.children) {
                convertTree(r.children);
              }
            });
          }
          convertTree(permissionRouters);

          permissionRouters.unshift({
            path: "/workbench",
            name: "index",
            component: Layout,
            meta: {
              title: "工作台",
              fullPath: "/workbench",
              isDashboard: true,
              affix: true,
              icon: "dashboard",
            },
            children: [
              {
                path: "",
                component: _import("/index"),
                meta: { title: "工作台", fullPath: "/workbench", isHide: true },
              },
            ],
          });

          // console.log(permissionRouters, 'permissionRouters');
          store.commit("SET_PERMISSION_ROUTERS", permissionRouters);
          router.addRoutes(permissionRouters);
          router.addRoutes([{ path: "*", redirect: "/workbench" }]);
          // console.log(permissionRouters);
          let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
          if (loginInfo) {
            if (loginInfo.ChangePwd == true) {
              next("/password");
              return;
            }
          }
          next({ path: to.path, replace: true });
        });
      }
    } else {
      // if (
      //   (from.meta.noAuth || to.meta.noAuth || from.path == "/") &&
      //   from.path !== "/register"
      // ) {
      //   if (pathList.indexOf(to.path.split("/")[1]) == -1) {
      //     next("/");
      //   } else {
      //     next("/register");
      //   }
      // } else {
      //   next("/register");
      // }
      // if (from.path == "/register") {
      //   NProgress.done();
      // }
      next('/register')
      if (from.path == "/register") {
          NProgress.done()
      }
    }
  }
  // next({ path: to.path, replace: true });
  // if(from.path=='/register'&&to.path=='/workbench') {
  //   console.log('rere')
  //   location.reload()
  //   sessionStorage.setItem('reload',1)
  // }
  // console.log('ssa',from.meta.re!=1,to.meta.re,from.meta.noAuth)
  if (from.meta.re != 1 && to.meta.re == 1 && from.meta.noAuth) {
    sessionStorage.setItem("loadMessage", 1);
  }
});

// router.afterEach((to, from) => {
//   NProgress.done();
//   if (to.meta) {
//     if (to.meta.title) {
//       if (to.meta.isFrontColumn) {
//         document.title = to.meta.title + " | " + store.state.sys.frontTitle;
//       } else {
//         document.title = to.meta.title + " | " + store.state.sys.title;
//       }
//     } else {
//       if (to.meta.isFrontColumn || to.meta.ColumnName == "维护中") {
//         document.title = store.state.sys.frontTitle;
//       } else {
//         document.title = store.state.sys.title;
//       }
//     }
//   } else {
//     document.title = store.state.sys.title;
//   }
//   // if (to.meta && to.meta.title) {
//   //   document.title = to.meta.title + ' | ' + to.meta.isFrontColumn?store.state.sys.frontTitle:store.state.sys.title
//   // } else {
//   //   document.title = to.meta.isFrontColumn?store.state.sys.frontTitle:store.state.sys.title
//   // }
// });
router.afterEach((to, from) => {
  NProgress.done()
  if (to.meta && to.meta.title) {
      document.title = to.meta.title + ' | ' + store.state.sys.title
  } else {
      document.title = store.state.sys.title
  }
})

export default router;
